// Generated types for PortDefinition
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { SysMLStructureReadAPI, SysMLStructureWriteAPI } from './sysmlstructure';
import { SysMLStructureReadAPISchemaObject, SysMLStructureWriteAPISchemaObject } from './sysmlstructure';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface PortDefinitionReadAPI extends SysMLStructureReadAPI {
}

export interface PortDefinitionWriteAPI extends SysMLStructureWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const PortDefinitionReadAPISchemaObject = SysMLStructureReadAPISchemaObject.extend({}).passthrough();
export const PortDefinitionReadAPISchema: z.ZodType<PortDefinitionReadAPI> = PortDefinitionReadAPISchemaObject;

export const PortDefinitionWriteAPISchemaObject = SysMLStructureWriteAPISchemaObject.extend({}).passthrough();
export const PortDefinitionWriteAPISchema: z.ZodType<PortDefinitionWriteAPI> = PortDefinitionWriteAPISchemaObject;
